import { IS_VERCEL_PROD } from '@monoimin/constants';

export const isProductionEnv = () => {
  const isVercelProd = process.env.VERCEL_ENV === 'production';
  const isNodeProd = process.env.NODE_ENV === 'production';

  const passOnProd = process.env.VERCEL_GIT_COMMIT_REF === 'prod';
  const passOnMain = process.env.VERCEL_GIT_COMMIT_REF === 'main';

  return (
    isVercelProd || (isNodeProd && IS_VERCEL_PROD) || passOnProd || passOnMain
  );
};
